import React, { useState } from "react";

import {
  defaultGapping,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  GSActionBar,
  GSEmptyList,
  GSItemList,
} from "golfstatus_react_components";
import { useDispatch, useSelector } from "react-redux";
import LeaderboardResultList from "../events/event/leaderboards/leaderboard-results-list";
import { useTheme } from "../../hooks/themeHooks";
import { getTime, getDateTimeOn } from "../../helpers/Dates";
import {
  getLeaderboard,
  selectFlights,
  selectLeaderboards,
  selectTVLeaderboards,
} from "../../reducers/leaderboardSlice";
import { useTournament } from "../../hooks/tournamentHooks";
import { getRouting } from "../../helpers/Converters";
import { eventBaseRoute } from "../../routes/event";
import { faPen, faSync } from "@fortawesome/free-solid-svg-icons";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const TVLeaderboardsWidget = (props) => {
  const { style } = props;
  const allLeaderboards = useSelector(selectLeaderboards);
  const leaderboards = useSelector(selectTVLeaderboards);
  const flights = useSelector(selectFlights);
  const tournament = useTournament();
  const navigate = useGolfstatusNavigate();
  const dispatch = useDispatch();

  const [updating, setUpdating] = useState("")

  const [, theme, getStyle] = useTheme();

  const getEmptyList = () => {
    return (
      <GSEmptyList
        style={{ ...defaultPadding.emptyListPad, ...defaultLayouts.fill }}
        title="No Leaderboards Yet"
        detail={<center>{`Leaderboards will become available just before the tournament starts${
          tournament?.startAt ? ` at ${getDateTimeOn(tournament?.startAt)}` : ""
        }.`}</center>}
        actions={[
          {
            title: "View Event Details",
            type: "grey",
            onClick: () => {
              navigate(getRouting(eventBaseRoute, [tournament?.publicUrl]));
            },
          },
        ]}
      />
    );
  };

  const getEmptySelectedList = () => {
    return (
      <GSEmptyList
        style={{ ...defaultPadding.emptyListPad, ...defaultLayouts.fill }}
        title="No Leaderboards"
        detail={`Please select a leaderboard.`}
        actions={[
          {
            title: "Edit Leaderboards",
            type: "grey",
            buttonIcon: faPen,
            onClick: () => {
              navigate(
                getRouting(eventBaseRoute, [
                  tournament?.publicUrl,
                  "leaderboards",
                  "tv",
                  "settings",
                ])
              );
            },
          },
        ]}
      />
    );
  };

  const getLeaderbaordView = (leaderboard, index) => {
    const leader = leaderboard.scores?.[0];
    const actions = [];
    if (leaderboard?.refreshedAt) {
      actions.push({
        actionIcon: faSync,
        title: updating === leaderboard?.id ? "updating...": `updated at ${getTime(leaderboard.refreshedAt)}`,
        type: " no-wrap secondary  mobile-icon",
        actionClick: () => {
          setUpdating(leaderboard?.id)
          dispatch(getLeaderboard(leaderboard.id)).then(() => {
            setUpdating("")
          });
        },
      });
    }
    return (
      <div
        id={leaderboard.id}
        style={{ ...defaultLayouts.vStack, ...defaultLayouts.fullWidth }}
      >
        <GSActionBar
          style={{
            ...defaultPadding.xLargePad,
            ...defaultLayouts.stickyTop,
            ...getStyle(theme.surface),
            zIndex: 1,
            borderBottom: "4px solid",
          }}
          header={
            <div
              style={{
                ...defaultGapping.mediumLargeGap,
                ...defaultLayouts.vStack,
              }}
            >
              <div>{leaderboard.name}</div>
              {leader?.position ? (
                <div
                  style={{ ...defaultTypography.body }}
                >{`Leader: ${leader?.name} (${leader?.netTotal})`}</div>
              ) : null}
            </div>
          }
          pageActions={actions}
        />
        <LeaderboardResultList
          leaderboard={leaderboard}
          flights={flights}
          readOnly={true}
          style={{ ...defaultPadding.xLargePad }}
          delay={index * 10000}
        />
      </div>
    );
  };

  if (allLeaderboards?.length === 0) {
    return getEmptyList();
  }

  if (leaderboards?.length === 0) {
    return getEmptySelectedList();
  }

  return (
    <GSItemList
      style={{
        ...defaultLayouts.fullWidth,
        ...style,
      }}
      listStyle={{
        ...defaultLayouts.fullWidth,
      }}
      type={"vertical"}
      items={leaderboards}
      listItem={(leaderboard, index) => getLeaderbaordView(leaderboard, index)}
    />
  );
};

export default TVLeaderboardsWidget;
